import React from "react";
import styled from "styled-components";
import GlobalFonts from "../../fonts/fonts"
import "../../fonts/font.css"	

import graphIcon from "../../images/graph_icon.png";
import reGraphIcon from "../../images/reverse_graph_icon.png";

import {NextButton} from "../button";
import AboutUs from "./about.pdf";

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 105px;
  left: 0px;

  background: linear-gradient(
    90.17deg, #EF8A57 31.25%, rgba(241, 157, 80, 0.99) 100%
  );
`;

const TextWapper = styled.div`
  position: relative;
  width: 700px;

  left: 10%;
  top: 40%;
`;

const Text = styled.text`
  position: relative;

  font-family: 'DX유니고딕';
  font-weight: 800;
  font-size: 25px;
  line-height: 29px;

  color: #ffffff;
  z-index : 1;

  span {
    font-family: 'DX유니고딕';
    font-weight: 100;
    font-size: 25px;
    line-height: 29px;

    color: #ffffff;
  }
`;

const GraphIcon = styled.img`
  width: 117px;
  height: 95px;

  position: absolute;
  bottom: 0;
  right: 10%;
`;
const ReGraphIcon = styled.img`
  width: 117px;
  height: 64px;

  position: absolute;
  top: 0;
  left: 10%;
`;


export default function Section2Banner() {
  const openPDF = () => {
    const pdfWindow = window.open("aboutUs");
    const title     = "AboutUs";
    const URI       = "aboutUs";
    const html      = `
      <html>
        <head>
          <title>${title}</title>
        </head>
        <body style="margin:0">
          <embed width="100%" height="100%" src=${AboutUs} type="application/pdf">
        </body>
      </html>
    `;
    pdfWindow.document.write(html);
    pdfWindow.document.close();
    pdfWindow.history.pushState(null, null, URI);
  };

  return (
    <Wrapper>
      <GlobalFonts />
      <GraphIcon src={graphIcon}></GraphIcon>
      <TextWapper>
        <Text>
          오픈 주차장에 대해 더 알고싶으신가요? <span>지금 확인해 보세요!</span>
        </Text>
      </TextWapper>
      <ReGraphIcon src={reGraphIcon}></ReGraphIcon>
      <NextButton onClick={openPDF} text="회사소개서 다운받기"/>
    </Wrapper>
  );
}
